import React from 'react';
import moment from 'moment';
import { Row, Col } from 'antd';
import { DivItems } from '../../../../components/EditForm/styles';
import { Text } from '../../../../components/Text';

export default function InfoProprietarioLeitura({ proprietario }) {
  const tituloSecao = proprietario?.detalheTipoCadastro;

  return proprietario?.pessoaFisicaCadastro?.cpf ? (
    <Col span={24} style={{ margin: '24px 0' }}>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text
            title="Nome"
            value={proprietario?.pessoaFisicaCadastro?.nome || '-'}
          />
        </Col>
        <Col span={8}>
          <Text
            title="CPF"
            value={
              proprietario?.pessoaFisicaCadastro?.cpf.replace(
                /(\d{3})(\d{3})(\d{3})(\d{2})/g,
                '$1.$2.$3-$4'
              ) || '-'
            }
          />
        </Col>
        <Col span={8}>
          <Text title="Contato" value={proprietario.telefone || '-'} />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text
            title="Nome da Mãe"
            value={proprietario?.pessoaFisicaCadastro?.nomeMae || '-'}
          />
        </Col>
        <Col span={8}>
          <Text
            title="Nome do Pai"
            value={proprietario?.pessoaFisicaCadastro?.nomePai || '-'}
          />
        </Col>
        <Col span={8}>
          <Text
            title="Nº id. do trabalhador (NIT)"
            value={proprietario.pessoaFisicaCadastro?.numeroPIS || '-'}
          />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text
            title="RNTRC"
            value={proprietario?.proprietarioCadastro?.rntrc || '-'}
          />
        </Col>
        <Col span={8}>
          <Text
            title="VALIDADE RNTRC"
            value={
              proprietario?.proprietarioCadastro?.vencimentoRNTRC
                ? moment(
                    proprietario?.proprietarioCadastro?.vencimentoRNTRC
                  ).format('DD/MM/YYYY')
                : '-'
            }
          />
        </Col>
        <Col span={8}>
          <Text title="Endereço" value={proprietario.endereco || '-'} />
        </Col>
      </Row>
    </Col>
  ) : (
    <Col span={24} style={{ margin: '24px 0' }}>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text
            title="Nome Fantasia"
            value={proprietario?.pessoaJuridicaCadastro?.nomeFantasia || '-'}
          />
        </Col>
        <Col span={8}>
          <Text
            title="CNPJ"
            value={proprietario?.pessoaJuridicaCadastro?.cnpj || '-'}
          />
        </Col>
        <Col span={8}>
          <Text
            title="Insc. Estadual"
            value={
              proprietario?.pessoaJuridicaCadastro?.inscricaoEstadual || '-'
            }
          />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text
            title="RNTRC"
            value={proprietario?.proprietarioCadastro?.rntrc || '-'}
          />
        </Col>
        <Col span={8}>
          <Text
            title="Validade RNTRC"
            value={
              proprietario?.proprietarioCadastro?.vencimentoRNTRC
                ? moment(
                    proprietario?.proprietarioCadastro?.vencimentoRNTRC || ''
                  ).format('DD/MM/YYYY')
                : '-'
            }
          />
        </Col>
        <Col span={8}>
          <Text title="Contato" value={proprietario?.telefone || '-'} />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={16}>
          <Text title="Endereço" value={proprietario?.endereco || '-'} />
        </Col>
      </Row>
    </Col>
  );
}
